import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { initSessionTimeout } from "./lib/security/secureStorage";

// Initialize security features
initSessionTimeout();

createRoot(document.getElementById("root")!).render(<App />);
